<div class="container-fluid p-4">
  @if (adminView) {
    <div class="card shadow mb-4">
      <div class="card-body d-grid gap-3">
        <div class="row g-3">
          @if (companyList.length > 0) {
            <mat-form-field class="col-12 col-md-4" subscriptSizing="dynamic">
              <mat-label>Company</mat-label>
              <input class="companyInput" type="text" placeholder="Pick one" aria-label="Company" matInput [formControl]="myControl" [matAutocomplete]="auto" [(ngModel)]="selectedCompany" />
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayCompanyCode">
                @for (company of filteredCompany | async; track company.ID) {
                  <mat-option [value]="company.ID">
                    {{ company.CompanyCode }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }
          <mat-form-field class="col-12 col-md-2" subscriptSizing="dynamic">
            <mat-label>Start Date</mat-label>
            <input matInput readonly [matDatepicker]="startDatePicker" name="startDate" [(ngModel)]="startDate" required [max]="sharedService.getTodayDate()" />
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker name="startDate"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="col-12 col-md-2" subscriptSizing="dynamic">
            <mat-label>End Date</mat-label>
            <input matInput readonly [matDatepicker]="endDatePicker" name="endDate" [(ngModel)]="endDate" [min]="startDate" required [max]="sharedService.getTodayDate()" />
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker name="endDate"></mat-datepicker>
          </mat-form-field>
        </div>
        @if (adminView) {
          <div class="row g-3">
            <div class="col-12 col-md-3">
              <div>Type</div>
              <select class="browser-default form-select" name="type" [(ngModel)]="filteredType" (ngModelChange)="changeFilteredSubtypeList(filteredType)">
                <option [value]="0"></option>
                @for (tt of filterTransactionTypeList; track tt) {
                  <option [value]="tt.ID">
                    {{ tt.Name }}
                  </option>
                }
              </select>
            </div>
            @if (filteredSubtypeList.length > 0) {
              <div class="col-12 col-md-3">
                <div>SubType</div>
                <select class="browser-default form-select" name="type" [(ngModel)]="filteredSubtype">
                  <option [value]="0"></option>
                  @for (tt of filteredSubtypeList; track tt) {
                    <option [value]="tt.ID">
                      {{ tt.Name }}
                    </option>
                  }
                </select>
              </div>
            }
          </div>
        }
        <div class="row g-3">
          <div class="col-12 col-md-3">
            <div class="card p-2 bg-warning-subtle border-warning-subtle">
              <mat-slide-toggle class="mat-slide-toggle-lg" [hideIcon]="true" color="warn" [(ngModel)]="showValid" name="showValid">Show valid and submitted sets </mat-slide-toggle>
            </div>
          </div>
          @if (adminView) {
            <div class="col-12 col-md-3">
              <div class="card p-2 bg-info-subtle border-info-subtle">
                <mat-slide-toggle class="mat-slide-toggle-lg" [hideIcon]="true" color="warn" [(ngModel)]="showBookmark" name="showValid">Show BOOKMARK Only </mat-slide-toggle>
              </div>
            </div>
          }
        </div>
        <div class="col-12 d-flex justify-content-end align-items-end">
          @if (sharedService.isRoles([enums.ADMIN, enums.FINANCE, enums.BOSS])) {
            <button class="btn btn-info me-1" (click)="showUnprocessedTransaction()">Show Unprocessed Transactions</button>
          }
          <button class="btn btn-dark" (click)="goToCompanySet()" [disabled]="disableSubmit">Apply</button>
        </div>
      </div>
    </div>
  }

  <div class="d-flex justify-content-between mb-3">
    <input type="text" placeholder="Search" aria-label="Search" class="form-control w-auto" name="searchText" [(ngModel)]="searchText" (keyup)="filterList()" />
    @if (sharedService.isBranchAccountHandler()) {
      <button class="btn btn-dark" (click)="openAddNewSetModal()">New Receipt</button>
    }
    @if (adminView) {
      <mat-button-toggle-group name="view" [(ngModel)]="isListView" (change)="changeListView()" required>
        <mat-button-toggle [value]="true"><i class="fas fa-list-ul"></i></mat-button-toggle>
        <mat-button-toggle [value]="false"><i class="fas fa-th-large"></i></mat-button-toggle>
      </mat-button-toggle-group>
    }
  </div>

  @if (setList?.length > 0) {
    <div class="row">
      @if (isListView) {
        <div class="col-12">
          <app-receipt-sets-listview [setList]="setList" [expenseSubtypeList]="expenseSubtypeList" [dlSubtypeList]="dlSubtypeList" (passEntry)="fetchData()"></app-receipt-sets-listview>
        </div>
      } @else {
        <div class="col-12">
          <p class="fw-bold">{{ setList.length }} results</p>
        </div>
        @for (set of setList; track set.ID) {
          <div class="col-12 col-lg-4 mb-3">
            <app-receipt-details [receipt]="set" [expenseSubtypeList]="expenseSubtypeList" [dlSubtypeList]="dlSubtypeList" [showValid]="showValid" [showBookmark]="showBookmark" (passEntry)="fetchData()"></app-receipt-details>
          </div>
        }
      }
    </div>
  } @else {
    <h3>Receipt List</h3>
    @if (searching) {
      <p>No search result for '{{ searchText }}'.</p>
    } @else {
      <p>You do not have any records here. You may add new receipt now</p>
    }
  }
</div>
